import React from "react"
import PropTypes from "prop-types"
import { Helmet } from "react-helmet"

import detailStyles from "./seo.module.css"

function SEO({ description, keywords, title }) {
  return (
    <Helmet
      htmlAttributes={{
        lang: `ja`,
      }}
      title={title}
      meta={[
        {
          name: `description`,
          content: description,
        },
        {
          name: `keywords`,
          content: keywords,
        },
      ]}
    >
      <body className={`bg-light ${detailStyles.towaBase}`} />
    </Helmet>
  )
}

SEO.defaultProps = {
  title: ``,
  description: ``,
  keywords: ``,
}

SEO.propTypes = {
  description: PropTypes.string.isRequired,
  keywords: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
}

export default SEO
